import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
import HomeCardLarge from "../common/HomeCardLarge";
// store
import { StoreContext } from "../../../../store/StoreProvider";
// config,utils
import { ROUTE_PATH } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";

// style
const StyledBoxBg = styled(Box, {})(({ theme }) => ({}));

const StyledContainer = styled(
  Container,
  {}
)(({ theme }) => ({
  paddingX: "80px",
}));

const BottomSec = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const handleClickGoBtn = () => {
    navigate(handleLocaleRoute(ROUTE_PATH.Signup));
  };

  return (
    <StyledBoxBg>
      <Box height="0px">
        {/* 背景 banner */}
        <Box
          style={{
            position: "relative",
            top: "175px",
            width: "100%",
            minHeight: "279px",
            backgroundColor: "#121212",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item>
              <Typography
                textAlign="center"
                variant="body1"
                sx={{ color: "#fff", height: "50px" }}
              >
                Copyright © 2022 by DaoYi Technology CO., LTD. All rights
                reserved.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <StyledContainer sx={{ position: "relative" }}>
        <HomeCardLarge
          title={intl.formatMessage({
            id: "home.bottomsec.title",
            defaultMessage: "探索與暢遊研究的更多可能",
          })}
          subTitle={intl.formatMessage({
            id: "home.bottomsec.subtilte",
            defaultMessage: "讓我們一起與您探索 更多網絡圖的可能",
          })}
          buttonText={intl.formatMessage({
            id: "home.bottomsec.btn.subscribe",
            defaultMessage: "前往註冊",
          })}
          buttonHref={handleLocaleRoute(ROUTE_PATH.Signup)}
          // onClick 跟 href 不能同時使用(會觸發2次navigate)
          // onClickGoBtn={handleClickGoBtn}
        />
      </StyledContainer>
    </StyledBoxBg>
  );
};

BottomSec.propTypes = {};

BottomSec.defaultProps = {};

export default BottomSec;
